import {creativeApi} from 'common/api/entitiesApi'
import {OwnedEntitySelector} from 'common/components/reloadable/OwnedEntitySelector'
import React from 'react'

export interface Props {
  advertiserId?: number
  value?: number
  onChange?: (value?: number | number[]) => void
  style?: React.CSSProperties
  disabled?: boolean
  placeholder?: string
  multiple?: boolean
  excludeIds?: number[]
}

export const CreativeSelectorFiltered = ({
                                           advertiserId,
                                           value,
                                           onChange,
                                           style,
                                           disabled,
                                           placeholder,
                                           multiple,
                                           excludeIds
                                         }: Props) => {

  const loadEntity = (id: number) => {
    return creativeApi.getCreative(id)
  }

  const searchEntities = (search: string, size: number, page: number, advId?: number) => {
    return creativeApi.creativeList(
      'name', 'asc', search,
      undefined, undefined, undefined, undefined,
      advId, undefined, { query: { size, page } }
    ).then((res: any) => {
      if (!excludeIds?.length) return res

      if (Array.isArray(res?.data)) {
        const filtered = res.data.filter((item: any) => !excludeIds.includes(item?.data?.id))
        return { ...res, data: filtered }
      }

      return res
    })
  }

  return (
    <OwnedEntitySelector
      ownerId={advertiserId}
      value={value}
      onChange={onChange}
      loadEntity={loadEntity}
      searchEntities={searchEntities}
      placeholder={placeholder}
      disabled={disabled}
      style={style}
      errorText="Can't load Creatives"
      multiple={multiple}
    />
  )
}